import { render } from "./SessionCleaner.vue?vue&type=template&id=54d911f9"
import script from "./SessionCleaner.vue?vue&type=script&lang=js"
export * from "./SessionCleaner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__